import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { ColorOptionDto2 } from '@/api-sdk';
import { BREAKPOINT_MEDIUM_PX } from '@/settings';
import { baseStyles } from '@/styles';

import './fg-color-option';

@customElement('fg-color-options-list')
export class FgColorOptionsList extends LitElement {
  @property({ type: String })
  stepTitle = '';

  @property({ type: Array })
  options?: ColorOptionDto2[];

  @property({ type: Boolean })
  isMultiSelectMode = false;

  render() {
    return html`
      ${this.stepTitle &&
      html`
        <p class="title"><strong>${this.stepTitle}</strong></p>
      `}

      <div class="options-list">
        ${this.options &&
        this.options.map(
          option => html`
            <fg-color-option
              .option=${option}
              .isMultiSelectMode=${this.isMultiSelectMode}
            ></fg-color-option>
          `,
        )}
      </div>
    `;
  }

  static styles = [
    baseStyles,
    css`
      .title {
        font-size: 1rem;
        margin-top: 10px;
      }

      .options-list {
        display: grid;
        gap: 10px;
        grid-template-columns: repeat(3, minmax(90px, 1fr));
        margin-top: 10px;
      }

      @media screen and (min-width: ${BREAKPOINT_MEDIUM_PX}px) {
        .options-list {
          grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
        }
      }
    `,
  ];
}
